<template>
    <Customers :customers="customers" />
</template>
<script>
import Customers from "./_components/Customers.vue";
import api from "src/services/api.js";
import { mutations } from "src/global-store.js";

export default {
    name: "CustomersModule",
    components: {
        Customers,
    },
    data() {
        return {
            customers: [],
        };
    },
    async created() {
        mutations.setNavbarTitle("Active Customers");
        try {
            this.customers = await api.get("/customers");
        } catch (error) {
            console.error(error);
        }
    },
};
</script>
